export interface ShippingPartner {
  _id: string;
  name: string;
  entityId: number;
  type: ShippingPartnerType;
  enabled: boolean;
  config: ShippingPartnerConfig;
  createdAt: Date;
  updatedAt: Date;
}

export interface ShippingPartnerConfig {
  apiToken?: string;
  pickupLocations?: string[];
  email?: string;
  password?: string;
  // Parcel Hub
  apiKey?: string;
  /** Parcel Hub account email, sent as `customer_email`. Not the buyer's email. */
  accountEmail?: string;
  warehouseId?: number;
  /** Falls back to warehouseId when unset. */
  returnWarehouseId?: number;
  sellerName?: string;
  sellerGstTin?: string;
}

export enum ShippingPartnerType {
  DELHIVERY = "DELHIVERY",
  WAYUVEGA = "WAYUVEGA",
  SHIPROCKET = "SHIPROCKET",
  PARCELHUB = "PARCELHUB"
}
